import { render, staticRenderFns } from "./PromotedEditModal.vue?vue&type=template&id=3a93c788"
import script from "./PromotedEditModal.vue?vue&type=script&lang=js"
export * from "./PromotedEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports